import React from "react"
import styled from "@emotion/styled"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import Media from "src/components/Media"
import TextLockup from "src/components/TextLockup"
import { mq, globals } from "src/styles"

const WrapperSection = styled(Section)`
  ${({ isFirstSection }) => (isFirstSection ? "" : "")}
  ${mq.mediumAndUp} {
    border-radius: var(--card-border-radius);
    overflow: hidden;
  }
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => hideMobile && "display: none"}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => hideDesktop && "display: none"}
  }
`

const ColumnWrapper = styled.div`
  ${({ mediaCol }) =>
    mediaCol
      ? `
    .gatsby-image-wrapper,
    .video-wrapper {
      width: 100%;
      height: 70vw;
    }
    ${mq.largerAndUp} {
      height: 100%;
      position: relative;
      .gatsby-image-wrapper,
      .video-wrapper {
        position: absolute !important;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  `
      : `
    ${mq.largerAndUp} {
      min-height: 30vw;
    }
  `}

  h1, h2 {
    max-width: 9em;
  }
  h3 {
    max-width: 11em;
  }
  h4,
  h5 {
    max-width: 24em;
  }
  h6 {
    max-width: 16em;
  }
  p {
    max-width: 40em;
  }
  ${mq.largeAndBelow} {
    ${({ imagePositionMobile }) => imagePositionMobile && "order: -1"}
  }
`

const TextWrapper = styled.div`
  padding-top: 6vw;
  padding-bottom: 8vw;
  ${mq.largerAndUp} {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    ${globals.verticalSpacing("padding-top")}
    ${globals.verticalSpacing("padding-bottom", 1.1)}
    height: 50vh;
    min-height: 35vw;
  }
`

const PageIntro = ({
  className,
  theme,
  spacing,
  prevTheme,
  nextTheme,
  media,
  mediaWidth = "large",
  width = "default",
  eyebrow,
  headingSize,
  headline,
  hideMobile,
  hideDesktop,

  _rawText,
  actions,
  verticalAlignment = "center",
  textAlignment = "left",
  isFirstSection,
  listType,
  id,
  imagePositionMobile,
}) => {
  const image = media?.image?.asset
  const video = media?.video?.asset

  if (!image && !video) {
    return false
  }

  // set responsive image sizes
  let sizes = "100vw"
  sizes = "(min-width: " + mq.mediumBreakpoint + "px) 50vw, 100vw"

  return (
    <Grid small="[1]" medium="m [1] m" large="[1]">
      <WrapperSection
        className={className}
        setTheme={theme}
        prevTheme={prevTheme}
        nextTheme={nextTheme}
        isFirstSection={isFirstSection}
        padded={false}
        id={id}
        vertical={spacing?.vertical}
        horizontal={spacing?.horizontal}
        hideMobile={hideMobile}
        hideDesktop={hideDesktop}
      >
        <div>
          <Grid
            small="[1]"
            large="[7] [7]"
            rowGap={false}
            vAlign="center"
            gridDirection="rtl"
          >
            {media && (
              <ColumnWrapper mediaCol>
                <Media
                  media={media}
                  sizes={sizes}
                  altText={headline || ''}
                  loading={isFirstSection ? "eager" : "lazy"}
                  // ratio={8 / 10}
                />
              </ColumnWrapper>
            )}

            <ColumnWrapper imagePositionMobile={imagePositionMobile}>
              <Grid small="m [1] m" medium="1 [12] 1" large="1 [7] 1">
                <TextWrapper>
                  <TextLockup
                    entranceDelay={1}
                    text={_rawText}
                    headingSize={headingSize ? headingSize : "h3"}
                    headline={headline}
                    actions={actions}
                    theme={theme}
                    listType={listType}
                    alignment={textAlignment}
                    transitionIn={false}
                    eyebrow={eyebrow}
                  />
                </TextWrapper>
              </Grid>
            </ColumnWrapper>
          </Grid>
        </div>
      </WrapperSection>
    </Grid>
  )
}

export default PageIntro
